document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-testimonials');
  
  sections.forEach(function(section) {
    const slides = section.querySelectorAll('.custom-testimonial-slide');
    const dots = section.querySelectorAll('.custom-testimonials__dot');
    const prevBtn = section.querySelector('.custom-testimonials__btn--prev');
    const nextBtn = section.querySelector('.custom-testimonials__btn--next');
    
    if (slides.length <= 1) return;

    let currentIndex = 0;

    function goToSlide(index) {
      slides[currentIndex].classList.remove('is-active');
      dots[currentIndex].classList.remove('is-active');
      
      currentIndex = index;
      if (currentIndex >= slides.length) currentIndex = 0;
      if (currentIndex < 0) currentIndex = slides.length - 1;
      
      slides[currentIndex].classList.add('is-active');
      dots[currentIndex].classList.add('is-active');
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToSlide(currentIndex + 1);
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        const index = parseInt(dot.getAttribute('data-index'), 10);
        goToSlide(index);
      });
    });
  });

  // Theme Editor alignment
  document.addEventListener('shopify:block:select', function(event) {
    if (event.target.classList.contains('custom-testimonial-slide')) {
      const slide = event.target;
      const section = slide.closest('.custom-testimonials');
      if (!section) return;
      
      const slides = Array.from(section.querySelectorAll('.custom-testimonial-slide'));
      const dots = section.querySelectorAll('.custom-testimonials__dot');
      const index = slides.indexOf(slide);
      
      slides.forEach(function(s) {
        s.classList.remove('is-active');
      });
      dots.forEach(function(d) {
        d.classList.remove('is-active');
      });
      
      slide.classList.add('is-active');
      if (dots[index]) {
        dots[index].classList.add('is-active');
      }
    }
  });
});
